
import Search from '../../Components/Explore/Search';
import Features from '../../Components/Features/Features';
import Hom from '../../Components/Hom/Hom';


function Home() {
  return (
    <div className="App">
     <Hom />
     <Features />
     <Search />
    </div>
  );
}

export default Home;
